import { render, staticRenderFns } from "./startFreeTrialButton.vue?vue&type=template&id=0c978f74&scoped=true&"
import script from "./startFreeTrialButton.vue?vue&type=script&lang=js&"
export * from "./startFreeTrialButton.vue?vue&type=script&lang=js&"
import style0 from "./startFreeTrialButton.vue?vue&type=style&index=0&id=0c978f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c978f74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContent,VRow})
